

import React from "react"
import { GreenButton } from "./GreenButton"

export const ContinueButton = (props) => {

    return (
        <GreenButton {...props} className={props.className}>Continue</GreenButton>
    )
}